export default {
  getAllRoles: (state) => state.roles,
  getSpecificRole: (state) => state.role,
  getSelectedRoles: (state) => state.selectedRoles,

  getRamais: (state) => state.ramais,
  getSelectedRamaisRelatoriosPABX: (state) =>
    state.selectedRamaisRelatoriosPABX,
  getSelectedRamaisMonitorRamais: (state) => state.selectedRamaisMonitorRamais,

  getTags: (state) => state.tags,
  getSelectedTagsRelatoriosPABX: (state) => state.selectedTagsRelatoriosPABX,
  getSelectedTagsPesquisaSatisfacao: (state) =>
    state.selectedTagsPesquisaSatisfacao,

  getConferencias: (state) => state.conferencias,
  getSelectedConferencias: (state) => state.selectedConferencias,

  getOperadores: (state) => state.operadores,
  getSelectedOperadores: (state) => state.selectedOperadores,

  getFilas: (state) => state.filas,
  getSelectedFilas: (state) => state.selectedFilas,

  getPesquisasSatisfacao: (state) => state.pesquisasSatisfacao,
  getSelectedPesquisasSatisfacao: (state) => state.selectedPesquisasSatisfacao,

  getDepartamentos:(state)=> state.departamentos,
  getSelectedDepartamentos: (state) => state.selectedDepartamentos,

  // ====

  getPermissoes: (state) => state.selectedPermissions,
};
